<template>
  <b-modal
    @show="onShow"
    header-class="dlg_header"
    :visible="visible"
    hide-footer
    centered
    @hide="onCancel"

  >
    <template #modal-header="{close}">
      <div class="popup_title " style="flex: 1; text-align: center;">{{ room.f_ho + $t('site_detail.ho') }}</div>
      <a class="dlg_close_btn" style="background-color: white" variant="white" @click="onCancel">
        <b-img :src="require('../../../assets/image/ic_close2.png')"
               style="height: 1em; margin-left: 7px; margin-right: 3px; "/>
      </a>
    </template>
    <div class="full container" style="overflow-y: auto; padding: 0;">
      <div class="align-vertical pb-2" style="padding-bottom:0">
        <div class="align-vertical mt-2" v-if="imageUrls.length > 0">
          <div class="align-vertical carousel_wrapper" style="position: relative">
            <div class="align-horizontal on_image_btn_wrapper" style="margin-bottom: -60px; margin-right: 10px;">
              <b-button class="btn btn_text download download_txt p-0" @click="downloadImage">
                {{ $t('common.download') }}
              </b-button>
            </div>
            <CCarousel
              v-model="activeIndex"
              :interval="0"
              cStyle="text-shadow: 1px 1px 2px #333; z-index: 0"
            >
              <b-carousel-slide
                v-for="img in imageUrls"
                :img-src="img"
              >
                <template slot="img">
                  <div class="slide-content" style="height: 300px">
                    <b-img
                      style="max-width: 100%; max-height: 100%;"
                      @click="galleryPopupShow=true"
                      :src="img"
                    />
                  </div>
                </template>
              </b-carousel-slide>
            </CCarousel>
            <!--            <carousel-indicator :length="imageUrls.length" :active="activeIndex"/>-->
          </div>
        </div>
        <div class="align-vertical info_wrapper">
          <div class="align-horizontal space_between width_100">
            <div class="report_desc_text">{{ $t('site_report.report_house_desc') }}</div>
            <b-button class="report download_txt p-1" @click="showHoReportPopup=true">
              {{ $t('site_report.report_btn') }}
            </b-button>
          </div>
          <div class="separator"/>
          <div class="align-horizontal mb-2" v-if="f_trans_type.includes('0')">
            <span class="caption_text2 mr-1">{{$t('room_info_popup.parcel_price1')}}</span>
            <span class="caption_text">{{room.f_site_inquire_price == 'Y' ? $t('site_detail.site_inquire') :
              (renderText(room.f_sale_price) + $t('room_info_popup.man_won'))}} /&nbsp; </span>
            <span class="caption_text2 mr-1">{{$t('site_detail.collateral')}}</span>
            <span class="caption_text">{{room.f_site_inquire_price == 'Y' ? $t('site_detail.site_inquire') :
              (renderText(room.f_collateral_price) + $t('room_info_popup.man_won'))}}</span>
          </div>
          <div class="align-horizontal mb-2" v-if="f_trans_type.includes('1')">
            <span class="caption_text2 mr-1">{{$t('interest.charter')}}</span>
            <span class="caption_text">{{room.f_site_inquire_charter == 'Y' ? $t('site_detail.site_inquire') :
              (renderText(room.f_charter_price) + $t('room_info_popup.man_won'))}}</span>
          </div>
          <div class="align-horizontal mb-2" v-if="f_trans_type.includes('2')">
            <span class="caption_text2 mr-1">{{$t('interest.invest')}}</span>
            <span class="caption_text">{{room.f_site_inquire_investment == 'Y' ? $t('site_detail.site_inquire') :
              (renderText(room.f_investment_price) + $t('room_info_popup.man_won'))}}</span>
          </div>
          <div class="align-horizontal mb-2" v-if="f_trans_type.includes('3')">
            <span class="caption_text2 mr-1">{{$t('map.deposit')}}</span>
            <span class="caption_text">{{room.f_site_inquire_month == 'Y' ? $t('site_detail.site_inquire') :
              (renderText(room.f_monthly_rent_deposit) + $t('room_info_popup.man_won'))}} /&nbsp; </span>
            <span class="caption_text2 mr-1">{{$t('interest.monthly')}}</span>
            <span class="caption_text">{{room.f_site_inquire_month == 'Y' ? $t('site_detail.site_inquire') :
              (renderText(room.f_monthly_rent) + $t('room_info_popup.man_won'))}}</span>
          </div>
          <div class="separator" style="margin-top: 3px;"/>
          <div class="align-horizontal mb-2 width_100">
            <span class="caption_text2 mr-1 flex_1">{{$t('site_detail.room') + "/" + $t('site_detail.toilet')}}</span>
            <span class="caption_text flex_1">{{renderText(room.f_room == 0 ? 1 : room.f_room == 1 ? 1.5 : room.f_room) + $t('room_info_popup.gae') +  "/" + renderText(room.f_toilet) + $t('room_info_popup.gae')}}</span>
          </div>
          <div class="align-horizontal mb-2 width_100">
            <span class="caption_text2 mr-1 flex_1">{{$t('room_info_popup.veranda') + "/" + $t('room_info_popup.utility_room')}}</span>
            <span class="caption_text flex_1">{{renderText(room.f_veranda) + $t('room_info_popup.gae') +  "/" + renderText(room.f_utility_room) + $t('room_info_popup.gae')}}</span>
          </div>
          <div class="align-horizontal mb-2 width_100">
            <span class="caption_text2 mr-1 flex_1">{{$t('room_info_popup.duplex') + "/" + $t('site_detail.teras')}}</span>
            <span class="caption_text flex_1">{{(room.f_duplex == 'Y' ? $t('map.exist') : $t('map.none')) +  "/" + (room.f_teras == 'Y' ? $t('map.exist') : $t('map.none'))}}</span>
          </div>
          <div class="align-horizontal mb-2 width_100">
            <span class="caption_text2 mr-1 flex_1">{{$t('map.exclusive_area')}}</span>
            <span class="caption_text flex_1">{{renderText(room.f_exclusive_size) + $t('room_info_popup.pyong')}}</span>
          </div>
        </div>
        <!--
        <div style="margin: 10px; align-self: stretch; border: solid 1px #bebdbd; border-radius: 3px; padding: 10px; min-height: 70px; margin-bottom: 0px;">
          <span class="input_memo" style="word-wrap: break-word; word-break: break-all;">{{room.f_memo}}</span>
        </div>
        -->
        <div v-if="room.f_memo != '' && room.f_memo != null">
          <div class="separator" style="margin-top: 3px;"/>
          <div
            style="margin: 10px; align-self: stretch; border: solid 1px #bebdbd; border-radius: 3px; padding: 10px; min-height: 70px; margin-bottom: 0px; max-height: 120px; ">
            <b-form-textarea readonly rows="5" class="input_memo" style="overflow: auto;border:none; resize: none;"
                             v-model="room.f_memo"></b-form-textarea>
          </div>
        </div>

      </div>
    </div>
    <Gallery
      :visible.sync="galleryPopupShow"
      :src="imageUrls"
      :current="activeIndex"
    />
    <HoReportPopup :visible.sync="showHoReportPopup" :site="site" :room="room"/>
  </b-modal>
</template>

<script>
import Utils from "../../../config/utils"
import MdSingleCheckBox from "../mf/MdSingleCheckBox";
import CarouselIndicator from "../CarouselIndicator";
import Gallery from "../Gallery";
import CCarousel from "../CCarousel";
import HoReportPopup from "./HoReportPopup";

export default {
  name: "RoomInfoPopup",
  components: {HoReportPopup, Gallery, CarouselIndicator, MdSingleCheckBox, CCarousel},
  data() {
    return {
      self: this,
      u: Utils,
      galleryPopupShow: false,
      showHoReportPopup: false,
      activeIndex: 0,
      imageUrls: [],
      f_trans_type: '',
    }
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    site: {
      type: Object,
      default: () => {
      }
    },
    room: {
      type: Object,
      default: () => {
      }
    }
  },
  methods: {
    onShow() {
      Utils.setState(this, {
        activeIndex: 0,
        imageUrls: this.room.f_image_urls.split(',').filter(it => {
          return it != ''
        }),
        f_trans_type: this.room.f_trans_type != null ? this.room.f_trans_type : ' ',
      });
    },
    onCancel() {
      this.$emit('update:visible', false)
    },
    renderText(text) {
      return text == '' || text == null || text == '0' ? '-' : Utils.currency(text);
    },

    downloadImage() {
      this.$emit('onDownload', this.imageUrls, `${this.room.f_ho}`);
    },
  }
}
</script>

<style scoped lang="scss">
@import "../../../assets/css/vars";

.dlg_content {
  background-color: $white;
  border-radius: 10px;
  margin: 80px 10px 60px 10px;
}

.wrapper {
  margin-top: 0;
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
  background-color: $white
}

.info_wrapper {
  margin: 12px 12px 5px 12px;
  align-items: flex-start
}

.info_row {
  margin-bottom: 10px;
  margin-left: 10px
}

.info_col1 {
  flex: 0.9;
  align-items: center
}

.info_col2 {
  flex: 1;
  align-items: center;
  margin-left: 24px
}

.cell {
  flex: 1;
  align-items: center;
  margin-bottom: 10px;
  width: 100%
}

.caption {
  width: 90px;
  text-align: center;
  justify-content: center
}

.caption_text {
  color: $black;
  font-size: $fs_18;
  font-family: $korean_gd_15_r;
}

.caption_text2 {
  color: $black;
  font-size: $fs_18;
  font-family: $korean_gd_14_r;
}

.caption_text1 {
  color: $black;
  font-size: $fs_14;
  font-family: $korean_gd_17_r;
}

.input {
  //width: 52px ;
  flex: 1;
  height: 50px;
  border-width: 0.5px;
  border-color: #bebdbd;
  border-radius: 3px;
  align-items: center;
  justify-content: center;
  margin: auto 5px;
  text-align: center;
  padding: 10px;
}

.input1 {
  width: 65px
}

.input_text {
  font-size: $fs_20;
  font-family: $korean_gd_14_r;
  color: $black
}

.input_memo {
  font-size: $fs_18;
  font-family: $korean_gd_14_r;
  color: $black;
  line-height: 30px;
  max-height: 100px;
}

.unit_text {
  width: 40px
}

.carousel_wrapper {
  margin: 12px 10px 0 10px;
  height: 100%
}

.pagination_wrapper {
  position: absolute;
  width: 100%;
  bottom: 0;
  padding-top: 0;
  padding-bottom: 0;
}

.pagination_dots {
  margin: auto -4px
}

.btn {
  width: 85px;
  align-items: center;
  justify-content: center;
  border-radius: 2px;
  background-color: $c_457fff;
  height: 36px;
}

.download {
  border-radius: 5px;
  height: 20px;
  background-color: $c_457fff;
}

.report {
  background-color: #154ABE;
  font-family: $korean_gd_15_r;
  font-size: $fs_16;
  border-radius: 5px;
  padding: 5px 10px;
}

.report_desc_text {
  color: #154ABE;
  font-size: $fs_18;
  font-family: $korean_gd_15_r;
}

.separator {
  height: 1px;
  background-color: #bebdbd;
  margin-bottom: 15px;
  margin-top: 15px;
  width: 100%;
}

.download_txt {
  color: $white;
}

.btn_text {
  color: $white;
  font-size: $fs_16;
  font-family: $korean_gd_15_r;
  text-align: center;
  width: 85px;
  height: 36px;
}

.on_image_btn_wrapper {
  justify-content: flex-end;
  top: 30px;
  right: 10px;
  z-index: 9999
}
</style>



// WEBPACK FOOTER //
// src/components/controls/popup/RoomInfoPopup.vue